// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import GeneralLoader from './components/GeneralLoader';
import GeneralConfirmDialog from './components/GeneralConfirmDialog';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { LoaderContextProvider } from './contexts/LoaderContext';
import { ConfirmDialogContextProvider } from './contexts/ConfirmDialogContext';

// ----------------------------------------------------------------------

export default function App() {
    return (
        <MotionLazyContainer>
            <ThemeProvider>
                <LoaderContextProvider>
                    <ConfirmDialogContextProvider>
                        <ThemeSettings>
                            <GeneralLoader>
                                <GeneralConfirmDialog>
                                    <NotistackProvider>
                                        <ProgressBarStyle />
                                        <ChartStyle />
                                        <ScrollToTop />
                                        <Router />
                                    </NotistackProvider>
                                </GeneralConfirmDialog>
                            </GeneralLoader>
                        </ThemeSettings>
                    </ConfirmDialogContextProvider>
                </LoaderContextProvider>
            </ThemeProvider>
        </MotionLazyContainer>
    );
}
